import React from 'react'
import { useLocation } from 'react-router-dom'

import TradingChart from '../../modules/exchange/old-components/TradingChart'

/**
 * ReactNativeMobileChart: TradingView chart for React Native (or other hosts) via WebView.
 * Same as MobileChart but supports URL query parameters for light/dark mode colors.
 * When no color params are provided, uses the same defaults as MobileChart.
 * @see README.md for URL params and postMessage API.
 */
function ReactNativeMobileChart() {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  // Chart params (same defaults as MobileChart)
  const type = queryParams.get('type') || 'candle'
  const theme = queryParams.get('theme') || 'dark'
  const pairId = queryParams.get('pair_id') || 'btcusd'
  const timeframe = queryParams.get('timeframe') || '4h'

  // Color params: URL-encoded (e.g. %23 for #). Omitted colors fall back to theme defaults.
  const toolbarBg = queryParams.get('toolbar_bg')
  const paneBg = queryParams.get('pane_bg')
  const upColor = queryParams.get('up_color')
  const downColor = queryParams.get('down_color')
  const areaColor = queryParams.get('area_color')

  const hasColorOverrides =
    toolbarBg !== null || paneBg !== null || upColor !== null || downColor !== null || areaColor !== null

  const colorOverrides = hasColorOverrides
    ? {
        ...(toolbarBg !== null && toolbarBg !== '' && { toolbar_bg: toolbarBg }),
        ...(paneBg !== null && paneBg !== '' && { pane_bg: paneBg }),
        ...(upColor !== null && upColor !== '' && { up_color: upColor }),
        ...(downColor !== null && downColor !== '' && { down_color: downColor }),
        ...(areaColor !== null && areaColor !== '' && { area_color: areaColor })
      }
    : undefined

  return (
    <TradingChart
      containerStyle={{
        height: '100vh',
        width: '100vw',
        borderRadius: 0,
        padding: 0
      }}
      urlTheme={theme}
      timeframe={timeframe}
      chartType={type}
      selectedMarketId={pairId}
      colorOverrides={Object.keys(colorOverrides || {}).length > 0 ? colorOverrides : undefined}
    />
  )
}

export default ReactNativeMobileChart
